export const {format}= new Intl.NumberFormat('hi-In',{
    style:'currency',
    currency:'THB'
})